// Custom code runs with every org variable and secret, so embed offers no Custom Function and core
// refuses new or changed code on embed saves.
export const withoutCustomCode = <T extends { value: string }>(
  options: T[],
  embed: boolean,
): T[] => (embed ? options.filter((option) => option.value !== 'CUSTOM_CODE') : options)

// An action that already runs custom code stays in embed, locked, so its stored code saves unchanged.
export const isLockedCustomCode = (
  actionType: string | null | undefined,
  embed: boolean,
): boolean => embed && actionType === 'CUSTOM_CODE'
